<template>
	<div class="convertarea">
		<newbullet :title="billet_tit" :loading="!createPup" :isshow.sync="createPup" :classlist="classlist"
			:fieldlist="field_create" @saveer="fnCreateSave" :savenew="false"></newbullet>

	</div>
</template>

<script>
	import {
		fn_retjson,
		retJSONArr,
		Basics_field,
		contrastDaily,

		fn_findeditid,
	} from "network/defaults";
	import {
		fn_newfield,
		// 合同
		getgroup_list,
		get_contract_list,
		add_contract1,
		// 回款
		hk_group_list,
		hkzd_fieldlist2,
		hkl_add_return,
	} from "network/hk_operset";
	import newbullet from "./newbullet.vue"
	export default {
		name: 'convertarea',
		props: {
			types: { // 1.商机转合同   2.合同转回款
				type: Number,
				default: 1,
			},
			isload: { // 是否可以打开当前弹出
				type: Boolean,
				default: false,
			},
			turndata: { // 转换所需保留的数据
				type: Array,
				default: () => {
					return []
				},
			},
			singleval: { // 关联id
				type: Object,
				default: () => {
					return {}
				},
			},


			memberlist: { // 
				type: Array,
				default: () => {
					return []
				},
			},


		},
		components: {
			newbullet,
		},
		watch: {
			isload() {
				if (this.isload) {
					this.setinitial()
				}
			},
			createPup() {
				if (!this.createPup) {
					this.handleClose()
				}
			}
		},
		created() {

		},
		methods: {
			// 弹出关闭
			handleClose() {
				this.field_initial = []
				this.curTurnlist = []
				this.classlist = []
				this.field_create = []
				this.savelist = []
				this.$emit("update:isload", false);
			},
			// 初始化  转换相当于新建
			setinitial() {
				this.curTurnlist = fn_retjson(this.turndata)
				this.fn_groupList()
				if (this.types == 1) {
					this.billet_tit = '转合同'
				}
				else if (this.types == 2) {
					this.billet_tit = '添加回款'
				}
			},
			// 获取字段分类
			fn_groupList(flag) {
				if (!this.classlist.length) {
					if (this.types == 1) { // 合同分类
						getgroup_list(999, 1).then((res) => {
							this.setgroups(res)
						});
					} else if (this.types == 2) { // 回款分类 
						hk_group_list(999, 1).then((res) => {
							this.setgroups(res)
						});
					}
				} else {
					this.getConfigfield()
				}
			},
			setgroups(res) {
				if (this.$handlereq(res)) {
					let obj = res.result.data || [];
					for (let item of obj) {
						item.type = item.group_id;
					}
					this.classlist = obj
					this.getConfigfield()
				}
			},
			// 获取字段列表
			getConfigfield() {
				if (this.field_initial.length) { // 已获取到初始字段，不用再获取
					let obj = fn_retjson(this.field_initial)
					this.setField_detail(obj)
				} else { // 未获取到初始字段
					if (this.types == 1) { // 合同
						get_contract_list(999, 1).then((res) => {
							this.setField_detail('', true, res)
						})
					} else if (this.types == 2) { // 回款
						hkzd_fieldlist2(999, 1).then((res) => {
							console.log(res,'hkzd_fieldlist2')
							this.setField_detail('', true, res)
						})
					}
				}
			},
			setField_detail(obj, flag, res) {
				if (flag) {
					if (res.code === 10000) {
						let c_arr = [];
						if(this.types == 1) {
							c_arr = res.result.data || []
						}
						else if(this.types == 2) {
							c_arr = res.result || []
						}
						// 未修改的初始字段
						this.field_initial = fn_retjson(c_arr)
						// 赋值改动字段
						this.handle_createField(c_arr)
						this.createPup = c_arr.length ? true : false;
						this.field_create = c_arr
					}
				} else {
					// 赋值改动字段
					this.handle_createField(obj)
					this.createPup = obj.length ? true : false;
					this.field_create = obj
					console.log(obj,'obj')
				}
			},
			// 处理字段  
			handle_createField(data) {
				for (let item of data) {
					fn_newfield(item, false)
					item.is_show = item.state ? true : false;
					let field = item.field || item.field_sign;
					if (this.types == 1) { // 转合同
						this.setContractField(item, field)
					} else if (this.types == 2) { // 转回款
						this.setReturnField(item, field)
					}
				}
			},
			fn_findFname(field_sign) { // 
				let index = this.curTurnlist.findIndex(v => v.field_sign == field_sign)
				if (index != -1 && this.curTurnlist[index]) {
					return this.curTurnlist[index].content
				} else {
					return ''
				}
			},
			setContractField(item, field_sign) { // 转合同 
				// required: 1 必填
				let requArr = ['合同名称', '合同客户', '合同联系人', '负责人']
				item.required = requArr.some(v => v == field_sign) ? 1 : 0;
				// 单个赋值
				if (field_sign == "合同名称") {
					item.field_type = 1;
					item.maxLength = 120;
					item.content = this.fn_findFname('商机名称')
				} else if (field_sign == "合同客户") {
					item.field_type = 9;
					item.trends = true
					item.field_list = []
					item.disabled = true;
					let index_ = this.curTurnlist.findIndex(v => v.field_sign == '商机客户')
					if (index_ != -1 && this.curTurnlist[index_]) {
						let c_obj = this.curTurnlist[index_]
						let c_content = c_obj.content
						if (typeof(c_content) == 'number') {
							item.content = c_obj.content
							item.singleval = {
								id: c_obj.content,
								name: c_obj.select_field,
							}
						}
					}
				} else if (field_sign == "签约日期") {
					item.field_type = 3;
					item.content = this.fn_findFname('预计签约')
				} else if (field_sign == "合同产品") {
					item.field_type = 20;
					item.content = this.fn_findFname("商机产品") || [];
					item.disabled = true;
				} else if (field_sign == "合同总金额") {
					item.field_type = 4;
					item.maxLength = 20;
					item.content = this.fn_findFname('商机预算')
				} else if (field_sign == "已收总额") {
					item.field_type = 4;
					item.maxLength = 20;
				} else if (field_sign == "合同附件") {
					item.field_type = 7;
					item.disabled = true;
					item.content = this.fn_findFname("商机附件") || [];
				} else if (field_sign == "关联商机") {
					item.field_type = 11;
					item.content = this.singleval.id || '';
					item.disabled = true;
					item.seltype = 5
					item.singleval = this.singleval
				} else if (field_sign == "负责人") {
					item.field_type = 5;
					item.content = this.fn_findFname("负责人")
					item.disabled = true;
					item.field_list = this.memberlist
				} else if (field_sign == "协同人") {
					item.field_type = 6;
					item.content = this.fn_findFname("协同人");
					item.disabled = true;
					item.field_list = this.memberlist
				} else if (field_sign == "备注信息") {
					item.field_type = 2;
					item.maxLength = 250;
				} else if (field_sign == "合同联系人") {
					item.field_type = 10;
					item.trends = true
				}
			},
			setReturnField(item, field_sign) { // 转回款
				// required: 1 必填
				let requArr = ['回款客户', '回款联系人', '负责人']
				item.required = requArr.some(v => v == field_sign) ? 1 : 0;
				// 单个赋值
				if (field_sign == "合同金额") {
					item.field_type = 4;
					item.maxLength = 20;
					item.disabled = true;
					item.content = this.fn_findFname('合同总金额')
				} else if (field_sign == "回款性质") {
					item.field_type = 5;
					item.field_list = [{
							id: 1,
							name: "收款",
						},
						{
							id: 2,
							name: "预收款",
						},
					];
					item.content = 1;

				} else if (field_sign == "回款日期") {
					item.field_type = 3;
				} else if (field_sign == "回款金额") {
					item.field_type = 4;
					item.maxLength = 20;
				} else if (field_sign == "回款客户") {
					item.field_type = 9;
					item.trends = true
					item.field_list = []
					item.disabled = true;
					let index_ = this.curTurnlist.findIndex(v => v.field_sign == '合同客户')
					if (index_ != -1 && this.curTurnlist[index_]) {
						let c_obj = this.curTurnlist[index_]
						let c_content = c_obj.content
						if (typeof(c_content) == 'number') {
							item.content = c_obj.content
							item.singleval = {
								id: c_obj.content,
								name: c_obj.select_field,
							}
						}
					}
				} else if (field_sign == "回款联系人") {
					item.field_type = 10;
					item.trends = true
					item.disabled = true;
				} else if (field_sign == "负责人") {
					item.field_type = 5;
					item.content = this.fn_findFname("负责人")
					item.disabled = true;
					item.field_list = this.memberlist
				} else if (field_sign == "回款附件") {
					item.field_type = 7;
					item.disabled = true;
					item.content = this.fn_findFname("合同附件") || [];
				} else if (field_sign == "合同源单") {
					item.field_type = 11;
					item.content = this.singleval.id || '';
					item.disabled = true;
					item.seltype = 7
					item.singleval = this.singleval
				}
				else if (field_sign == "协同人") {
					item.field_type = 6;
					item.content = this.fn_findFname("协同人");
					item.disabled = true;
					item.field_list = this.memberlist
				} 
			},
			// 确定
			fnCreateSave(e) {
				if (e && e.fieldlist) {
					let {
						fieldlist
					} = e
					this.savelist = retJSONArr(fieldlist) || [];
					let resdata = this.fn_Savedatas()
					if (this.types == 1) { // 转合同
						this.addContracts(resdata)
					}
					else if (this.types == 2) { // 转回款
						this.addReturens(resdata)
					}
				}
			},
			// 转合同
			addContracts(data) { 
				add_contract1(data).then((res) => {
					if (this.$handlereq(res)) {
						this.$alertMess("添加成功");
						this.createPup = false
					}
				});
			},
			// 转回款
			addReturens(data) {
				hkl_add_return(data).then((res) => {
					if (this.$handlereq(res)) {
						this.$alertMess("添加成功");
						this.createPup = false
					}
				});
			},
			// 保存数据处理
			fn_Savedatas() {
				let currobj = this.savelist;
				let newArr = Basics_field(currobj);
				let fd = new FormData();
				let assistant = this.findfont("协同人");
				if (assistant && assistant.length) {
					fd.append("assistant_member_id", assistant.join(",") + ",");
				}
				if (this.types == 1) {  // 合同
					this.fn_circulatedata(fd, this.Refer_contract)
					this.fn_circulatedata(fd, this.Refer_contTime, true)
					fd.append("contract_info", JSON.stringify(newArr));
				}
				else if (this.types == 2) {   // 回款
					this.fn_circulatedata(fd, this.Refer_returen)
					this.fn_circulatedata(fd, this.Refer_retuTime, true)
					fd.append("return_info", JSON.stringify(newArr));
				}
				
				return fd;
			},
			// 设置post值
			fn_circulatedata(fd, cArr, isTime) {
				for (let i = 0; i < cArr.length; i++) {
					let {
						name,
						key
					} = cArr[i]
					let res_ = this.findfont(name) + ''
					if (res_ != undefined && res_ != '') {
						if (isTime) { // 时间日期
							let len = (res_ + "").length;
							let time_Res = len > 10 ? ((res_ + '').slice(0, 10) * 1) : res_;
							fd.append(key, time_Res);
						} else {
							fd.append(key, res_);
						}
					}
				}
			},
			findfont(field) {
				if (this.savelist.length) {
					let index = this.savelist.findIndex((v) => v.field_sign == field || v.field == field);
					if (index != -1) {
						return this.savelist[index].content;
					} else {
						return "";
					}
				}
			},
		},
		data() {
			return {
				billet_tit: '',
				createPup: false,
				classlist: [],
				field_create: [],
				field_initial: [],

				curTurnlist: [],

				savelist: [],
				
				

				Refer_contract: [{
						key: 'name',
						name: '合同名称',
					},
					{
						key: 'customer_id',
						name: '合同客户',
					},
					{
						key: 'contact_id',
						name: '合同联系人',
					},
					{
						key: 'member_id',
						name: '负责人',
					},
					{
						key: 'chance_id',
						name: '关联商机',
					},
					{
						key: 'money',
						name: '合同总金额',
					},
				],
				Refer_contTime: [{
					key: 'signing_time',
					name: '签约日期',
				}, ],
				
				
				Refer_returen: [
					{
						key: 'customer_id',
						name: '回款客户',
					},
					{
						key: 'contact_id',
						name: '回款联系人',
					},
					{
						key: 'member_id',
						name: '负责人',
					},
					{
						key: 'contract_id',
						name: '合同源单',
					},
					{
						key: 'return_nature',
						name: '回款性质',
					},
					{
						key: 'return_money',
						name: '回款金额',
					},
				],
				Refer_retuTime: [{
					key: 'return_time',
					name: '回款日期',
				}, ],
				
				 
			}
		},
	}
</script>

<style lang="scss" scoped>

</style>